export const generatedUiFidelityApprovalPacket = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-22T00:00:00.000Z",
  "mode": "deterministic-ui-fidelity-approval-packet",
  "operatingRule": "This packet is a reviewer aid for side-by-side visual approval. It does not approve the UI, release, customer use, or commercial use.",
  "sourceLedgerHash": "sha256-857d823d3c191fe56b18c0fbf5c3c1fdffa61d86ed2ca03009a76bb5113f1e58",
  "sourceLedgerPath": "public/ui-fidelity-ledger.json",
  "htmlPath": "public/ui-fidelity-review/index.html",
  "markdownPath": "public/ui-fidelity-review-packet.md",
  "assetDirectory": "public/ui-fidelity-review/assets",
  "pageCount": 6,
  "copiedReferenceAssetCount": 6,
  "copiedRenderedAssetCount": 6,
  "ownerApprovalAllowed": false,
  "releaseApprovalAllowed": false,
  "customerUseAllowed": false,
  "commercialUseAllowed": false,
  "requiredApprovalAction": "Review each reference/rendered pair in the generated HTML packet, record owner decision, and regenerate artifacts.",
  "blockers": [
    "Owner side-by-side visual approval is not recorded.",
    "Pixel/semantic tolerance has not been accepted by product owner.",
    "Approval fields are intentionally locked to pending until a reviewed decision artifact exists."
  ],
  "pageRecords": [
    {
      "id": "command-overview",
      "label": "Command Overview",
      "fidelityState": "captured-awaiting-owner-side-by-side-approval",
      "referenceAssetPath": "/ui-fidelity-review/assets/command-overview-reference-command-overview.png",
      "renderedAssetPath": "/ui-fidelity-review/assets/command-overview-rendered-command-overview-desktop.png",
      "referenceSha256": "sha256-6cde350718f2d48df3c030e5d4c7e4c73042e9ccff8fbf65c8a5c5b60d625e9b",
      "renderedSha256": "sha256-8b8edee9eca6e8e21bab2c19553a4de726d5f8a48f5ccd36c4523bc4f6a1785f",
      "pageHash": "sha256-98b89f61e030e3ef30fa94b61c8fca5dcdf11a9a5128e8752d0743de687404a2",
      "comparison": {
        "comparable": true,
        "referenceAspectRatio": 1.405482,
        "renderedAspectRatio": 1.5,
        "aspectRatioDelta": 0.094518,
        "samePixelDimensions": false
      },
      "ownerDecision": "pending",
      "ownerApprovalAllowed": false,
      "releaseApprovalAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "requiredDecision": "Owner must approve, reject, or create a page-specific mismatch work order after side-by-side review.",
      "reviewItemHash": "sha256-5b387ebdb3b2396ef6100d85df1841a50152fefc74ecf256aba5dba2847dc23c"
    },
    {
      "id": "scenario-compare",
      "label": "Scenario Compare",
      "fidelityState": "captured-awaiting-owner-side-by-side-approval",
      "referenceAssetPath": "/ui-fidelity-review/assets/scenario-compare-reference-scenario-compare.png",
      "renderedAssetPath": "/ui-fidelity-review/assets/scenario-compare-rendered-scenario-compare-desktop.png",
      "referenceSha256": "sha256-286c613f80e9c30deede278485b12a11a2a9b9bfe7380f3c0cf5f371cac1a360",
      "renderedSha256": "sha256-0ae22da4c49c0316efab0cebe96eb61ad2248c2faa88f4180dbd55f05f9f6b82",
      "pageHash": "sha256-6c35b01d7df68ed6906b3dadfe61778cea64c82899ec34e95152529d05e62574",
      "comparison": {
        "comparable": true,
        "referenceAspectRatio": 1.405482,
        "renderedAspectRatio": 1.5,
        "aspectRatioDelta": 0.094518,
        "samePixelDimensions": false
      },
      "ownerDecision": "pending",
      "ownerApprovalAllowed": false,
      "releaseApprovalAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "requiredDecision": "Owner must approve, reject, or create a page-specific mismatch work order after side-by-side review.",
      "reviewItemHash": "sha256-82336eb1a91d991494d19f206068dc927d41f389b30405a974aa06ec62440be9"
    },
    {
      "id": "solar-clock",
      "label": "Solar Clock",
      "fidelityState": "captured-awaiting-owner-side-by-side-approval",
      "referenceAssetPath": "/ui-fidelity-review/assets/solar-clock-reference-solar-clock.png",
      "renderedAssetPath": "/ui-fidelity-review/assets/solar-clock-rendered-solar-clock-desktop.png",
      "referenceSha256": "sha256-a597e9c2fa7c8c779e6af4336bb209bcbb5314cb1edeabb3accde75069ee103b",
      "renderedSha256": "sha256-69086aaabc1e056422d3b02ebd239fb03fb4473aa8507c3b298b8d5ca8f49ea2",
      "pageHash": "sha256-4dd0967fe9ca6aa82f1448c08e1b65f27c87ae1f72ce7f968e1ff5b278c786c2",
      "comparison": {
        "comparable": true,
        "referenceAspectRatio": 1.405482,
        "renderedAspectRatio": 1.5,
        "aspectRatioDelta": 0.094518,
        "samePixelDimensions": false
      },
      "ownerDecision": "pending",
      "ownerApprovalAllowed": false,
      "releaseApprovalAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "requiredDecision": "Owner must approve, reject, or create a page-specific mismatch work order after side-by-side review.",
      "reviewItemHash": "sha256-22cd0c206daa69d3378d3f785d7e8acc094a3ead8a56d6ed8799a60c375ea705"
    },
    {
      "id": "body-ledger",
      "label": "Body Ledger",
      "fidelityState": "captured-awaiting-owner-side-by-side-approval",
      "referenceAssetPath": "/ui-fidelity-review/assets/body-ledger-reference-body-ledger.png",
      "renderedAssetPath": "/ui-fidelity-review/assets/body-ledger-rendered-body-ledger-desktop.png",
      "referenceSha256": "sha256-b71ff86599eff2632c67aba558101e182dc03a78c34e3311270db7d73e2ea21b",
      "renderedSha256": "sha256-cc3e583696ac13af140b201a63ff68b4cf756c6e917df91ab11d6cd192e08149",
      "pageHash": "sha256-83d4be8762f659a85efa76e7565825aee038ff5af8f323140c9a97dadbc7d356",
      "comparison": {
        "comparable": true,
        "referenceAspectRatio": 1.405482,
        "renderedAspectRatio": 1.5,
        "aspectRatioDelta": 0.094518,
        "samePixelDimensions": false
      },
      "ownerDecision": "pending",
      "ownerApprovalAllowed": false,
      "releaseApprovalAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "requiredDecision": "Owner must approve, reject, or create a page-specific mismatch work order after side-by-side review.",
      "reviewItemHash": "sha256-25ac754e58c23dd01338a3a09c06439588ff9659bff51d27ec706962582aacc9"
    },
    {
      "id": "process-lab",
      "label": "Process Lab",
      "fidelityState": "captured-awaiting-owner-side-by-side-approval",
      "referenceAssetPath": "/ui-fidelity-review/assets/process-lab-reference-process-lab.png",
      "renderedAssetPath": "/ui-fidelity-review/assets/process-lab-rendered-process-lab-desktop.png",
      "referenceSha256": "sha256-9b0f5c1356275d8cb61342d71cdec98146e1ad83fa6df5d4fad88ebddb332119",
      "renderedSha256": "sha256-88167e14fd917a03ba9518185525dfff632a024d053adb91885c574224967447",
      "pageHash": "sha256-418d262e8828d43508e7eb9ddc8f4c0ac03d960eeb50277c799a9f8e258d90b3",
      "comparison": {
        "comparable": true,
        "referenceAspectRatio": 1.405482,
        "renderedAspectRatio": 1.5,
        "aspectRatioDelta": 0.094518,
        "samePixelDimensions": false
      },
      "ownerDecision": "pending",
      "ownerApprovalAllowed": false,
      "releaseApprovalAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "requiredDecision": "Owner must approve, reject, or create a page-specific mismatch work order after side-by-side review.",
      "reviewItemHash": "sha256-995462a43f3bc19dbfa2158d59996773d3f33926478ac0e45b83dfa48c996c6c"
    },
    {
      "id": "claims-register",
      "label": "Claims Register",
      "fidelityState": "captured-awaiting-owner-side-by-side-approval",
      "referenceAssetPath": "/ui-fidelity-review/assets/claims-register-reference-claims-register.png",
      "renderedAssetPath": "/ui-fidelity-review/assets/claims-register-rendered-claims-register-desktop.png",
      "referenceSha256": "sha256-5c1adf7727684bee9081bed9603a648c77b52ccc164b03f3f96b8399042cb3d4",
      "renderedSha256": "sha256-1c534bbf4206d038c6f045a3af110fbd06e8b0bd09c95021045f45ef66a9dac2",
      "pageHash": "sha256-6852676021239079f912197ace158e4147b0c1ff305440fbe074d3ace3774cbe",
      "comparison": {
        "comparable": true,
        "referenceAspectRatio": 1.405482,
        "renderedAspectRatio": 1.5,
        "aspectRatioDelta": 0.094518,
        "samePixelDimensions": false
      },
      "ownerDecision": "pending",
      "ownerApprovalAllowed": false,
      "releaseApprovalAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "requiredDecision": "Owner must approve, reject, or create a page-specific mismatch work order after side-by-side review.",
      "reviewItemHash": "sha256-089245b85831722fb97894f719132cb7e57020d54fdc8d97913dcf15ef3f8961"
    }
  ],
  "packetHash": "sha256-a9ebbc25e00bd64e0c64d0dee15a0a7d2e2241270ff75c11ba09c6c81568bdb6",
  "markdownHash": "sha256-05a0b84d258c7d64e712af16ed57ff3d591f27ce6eeccb87b76ef74a9259538a"
}
;
